<section id="shift-form">
    <form [formGroup]="shiftForm" (ngSubmit)="onFormSubmit()">
        <div class="modal-header">
            <h4 class="modal-title">
                {{ title }}
            </h4>
            <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-6">
                    <fieldset class="form-group">
                        <label for="name">Nombre</label>
                        <label *ngIf="shiftForm.get('name')?.hasError('required')" class="red-text h5 ml-1 mb-0">
                            *
                        </label>
                        <input type="text" id="name" formControlName="name" class="form-control">
                        <div *ngIf="shiftForm.get('name')?.hasError('notBlank') && shiftForm.get('name')?.touched"
                            class="alert red-bg-light text-black mt-2">
                            El nombre del turno no puede estar vacío.
                        </div>
                    </fieldset>
                </div>
                <div class="col-md-6">
                    <fieldset class="form-group">
                        <label for="color">Color</label>
                        <label *ngIf="shiftForm.get('color')?.hasError('required')" class="red-text h5 ml-1 mb-0">
                            *
                        </label>
                        <div class="input-color-container">
                            <input type="color" id="color" formControlName="color" class="form-control w-25">
                            <div class="default-colors">
                                <span *ngFor="let c of DEFAULT_COLORS" class="color-swatch" [style.background]="c"
                                    (click)="shiftForm.get('color')?.setValue(c)">
                                </span>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <fieldset class="form-group">
                        <label for="start">Hora Inicio</label>
                        <label *ngIf="shiftForm.get('start')?.hasError('required')" class="red-text h5 ml-1 mb-0">
                            *
                        </label>
                        <ngb-timepicker formControlName="start"></ngb-timepicker>
                    </fieldset>
                </div>
                <div class="col-md-6">
                    <fieldset class="form-group">
                        <label for="end">Hora Fin</label>
                        <label *ngIf="shiftForm.get('end')?.hasError('required')" class="red-text h5 ml-1 mb-0">
                            *
                        </label>
                        <ngb-timepicker formControlName="end"></ngb-timepicker>
                    </fieldset>
                </div>
            </div>
            <div *ngIf="shiftForm.hasError('timesAreEqual') 
            && (shiftForm.get('start')?.touched || shiftForm.get('end')?.touched)"
                class="alert red-bg-light text-black mt-2">
                Las horas no pueden ser las mismas.
            </div>
        </div>
        <div class="modal-footer">
            <button type="submit" class="btn btn-success" [disabled]="shiftForm.invalid">{{ submitText }}</button>
            <button type="button" class="btn btn-secondary" (click)="activeModal.close('Close click')">Cerrar</button>
        </div>
    </form>
</section>